import { gridProductKey } from "../keys";
import { isEmptyString } from "../validations";
import type { CustomizationHandler } from "./types";

/**
 * The price on every product-grid card: category, search and home listings,
 * and the product page's related products.
 *
 * Core themes mark each card with `data-product-type="list"`, in all 24 with
 * NubeSDK slots, whether the card is the theme's own template or Core's
 * `product-item` component. The product page and the quick shop never carry
 * it, which keeps this apart from `product-detail-price`.
 *
 * Every card shows a different price, so apps usually pass a resolver, which
 * `identify` maps back to each card through its product id.
 *
 * @see ./README.md
 */
export const productGridItemPrice: CustomizationHandler<"product-grid-item-price"> =
	{
		host: "storefront",
		selector: '[data-product-type="list"] .js-price-display',

		read(element) {
			return { text: element.textContent ?? "" };
		},

		operation(element, options) {
			// `textContent` only: the numeric price the theme computes from
			// lives in attributes, which this leaves untouched.
			if (options.text !== undefined) element.textContent = options.text;
		},

		values(element) {
			return {
				// What the shopper reads, trimmed like the button's label.
				text: (element.textContent ?? "").trim(),
			};
		},

		identify: gridProductKey,

		validate(_element, options) {
			if (options.text !== undefined && isEmptyString(options.text)) {
				return 'refused "text": a price cannot be blank';
			}
			return null;
		},
	};
